/**
 * Публичная регистрация клиента (E08): wizard и отдельная страница.
 */

import { z } from "zod";
import { apiSuccessSchema } from "./envelope";

export const registerClientRequestSchema = z.object({
  company: z.string().trim().min(1).max(255),
  position: z.string().trim().min(1).max(255),
  fullName: z.string().trim().min(1).max(255),
  phone: z.string().trim().min(1).max(64),
  email: z.string().trim().email().max(255),
  /** Как у staff: минимум 12 символов (Q8). */
  password: z.string().min(12).max(256),
  region: z.string().trim().max(255).nullable().optional(),
  deliveryObject: z.string().trim().max(512).nullable().optional(),
  consentAccepted: z.literal(true),
  captchaToken: z.string().optional(),
});
export type RegisterClientRequest = z.infer<typeof registerClientRequestSchema>;

export const registerClientResultSchema = z.object({
  clientId: z.string().uuid(),
  personalCode: z.string().length(8),
  linkedProjectCount: z.number().int().nonnegative(),
});
export type RegisterClientResult = z.infer<typeof registerClientResultSchema>;

export const registerClientResultResponseSchema = apiSuccessSchema(registerClientResultSchema);

export const CLIENT_REGISTRATION_ERROR_CODES = {
  PROJECT_NOT_FOUND: "CLIENT_REGISTRATION_PROJECT_NOT_FOUND",
  PROJECT_ALREADY_REGISTERED: "CLIENT_REGISTRATION_PROJECT_ALREADY_REGISTERED",
  EMAIL_TAKEN: "CLIENT_REGISTRATION_EMAIL_TAKEN",
} as const;
export type ClientRegistrationErrorCode =
  (typeof CLIENT_REGISTRATION_ERROR_CODES)[keyof typeof CLIENT_REGISTRATION_ERROR_CODES];
